import { render, staticRenderFns } from "./MensagemAssinaturaNaoDisponivel.vue?vue&type=template&id=f9351cee&"
import script from "./MensagemAssinaturaNaoDisponivel.vue?vue&type=script&lang=js&"
export * from "./MensagemAssinaturaNaoDisponivel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports